import { lazy } from "react";

const TransactionHistoryPage = lazy(() => import("./main"));

export { TransactionHistoryPage };
